import React from 'react';
import Loading from '../views/generic/LoadingView';
import StoryMixerResultsView from '../views/storyMixer/StoryMixerResultsView';
import * as CarouselItemSelector from '../../data/CarouselItemSelector';
import withOtsEnabled from './helper/withOtsEnabled';

const StoryMixerResultsContainer = (props) => {
    if(props.isLoading){
       return <Loading/>
    }
    else if(props.storyMixerResultData){
       return <StoryMixerResultsView resultData={CarouselItemSelector.projectCarouselResults(props.storyMixerResultData)} {...props} />
    } else {
        return null;
    }
}

export default withOtsEnabled(StoryMixerResultsContainer);



// WEBPACK FOOTER //
// ./src/react/containers/StoryMixerResultsContainer.jsx